module.exports = __webpack_public_path__ + "assets/img/honor2.4de546f6.jpg";